import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Currency from '../../../containers/Currency';
import { roundDownSmallValue } from '@xanadu/ui-shared/utils/numbers';
import styles from './Wallet.module.scss';

const PendingGame = ({
  amount,
  gameName
}) => (
  <div className={styles.row}>
    <span className={styles.key}>
      Pending Game
    </span>
    <span className={styles.value}>
      {gameName} <Currency value={amount / 100} />
    </span>
  </div>
);

PendingGame.propTypes = {
  gameName: PropTypes.string.isRequired,
  amount: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ]).isRequired,
};

export default class Wallet extends Component {
  static get propTypes() {
    return {
      name: PropTypes.string.isRequired,
      wallet: PropTypes.object.isRequired,
      status: PropTypes.number,
      loading: PropTypes.bool,
      isLegacyWallet: PropTypes.bool,
    };
  }

  static get defaultProps() {
    return {
      status: 200,
    };
  }

  renderOutage = () => (
    <div className={`${styles.balances} ${styles.unavailableBalance}`}>
      <span className={styles.unavailableImage} />
      <span className={styles.unavailableText}>Wallet Currently Unavailable.</span>
    </div>
  );

  renderLoading = () => (
    <div className={styles.unavailable}>
      <span className={styles.unavailableImage} />
      <span className={styles.unavailableText}>Loading your wallet...</span>
    </div>
  );

  render() {
    if (this.props.loading) {
      return this.renderLoading();
    }

    if (this.props.status !== 200) {
      return this.renderOutage();
    }
    const { isLegacyWallet } = this.props;

    return (
      <div className={styles.wallet}>
        <span className={styles.title}>{this.props.name}</span>
        <div className={styles.valuesContainer}>
          <div className={styles.row}>
            <span className={`${styles.key} ${styles['key--wallet']}`} data-hook="rhs-mywallet">
              {isLegacyWallet ? 'Old Wallet' : 'My Wallet'}
            </span>
            <span className={styles.value} data-hook="rhs-mywallet-balance">
              <Currency value={roundDownSmallValue(this.props.wallet.balance)} />
            </span>
          </div>
          {isLegacyWallet ? null : (<div className={styles.row}>
            <span className={`${styles.key} ${styles['key--exposure']}`} data-hook="rhs-exposure">
              Exposure
            </span>
            <span className={styles.value} data-hook="rhs-exposure-balance">
              <Currency value={roundDownSmallValue(this.props.wallet.exposure)} />
            </span>
          </div>)}
          {isLegacyWallet ? null : (<div className={styles.row}>
            <span className={`${styles.key} ${styles['key--available']}`} data-hook="rhs-mywalletavailable">
              Available
            </span>
            <span className={styles.value} data-hook="rhs-mywalletavailable-balance">
              <Currency value={roundDownSmallValue(this.props.wallet.freeFunds)} round="floor" />
            </span>
          </div>)}
        </div>
      </div>
    );
  }
}
